export default "__VITE_ASSET__BqvX_JN7__"